import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { checkPermission } from '../../Utils/permissionHelper';

const AddButton = ({
    to,
    children = 'Add',
    className = '',
    permission = null,
    disabled = false,
    onClick
}) => {
    const isDisabled = disabled || (permission && !checkPermission(permission));

    if (isDisabled) {
        return (
            <button
                className={`button button-them-gray admin-btn ${className}`}
                disabled={true}
                style={{ opacity: 0.6, cursor: 'not-allowed' }}
            >
                <AddIcon style={{ fontSize: '20px', marginRight: '4px' }} /> {children}
            </button>
        );
    }

    if (onClick) {
        return (
            <button
                type="button"
                onClick={onClick}
                className={`button button-them-gray admin-btn ${className}`}
                disabled={isDisabled}
                style={{ opacity: isDisabled ? 0.6 : 1, cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            >
                <AddIcon style={{ fontSize: '20px', marginRight: '4px' }} /> {children}
            </button>
        );
    }

    return (
        <Link to={to} className={`button button-them-gray admin-btn ${className}`}>
            <AddIcon style={{ fontSize: '20px', marginRight: '4px' }} /> {children}
        </Link>
    );
};

export default AddButton;


